import React from "react";

function CommonModal({
    isOpen,
    onClose,
    type = "alarm", // "alarm" | "confirm"
    title,
    message,
    children,
    size = "md",
    showCloseButton = true,
    closeOnBackdrop = true,
    onConfirm,
    onCancel,
    confirmText = "확인",
    cancelText = "취소",
}) {
    if (!isOpen) return null;

    const sizeClasses = {
        sm: "w-[400px]",
        md: "w-[600px]",
        lg: "w-[800px]",
        xl: "w-[1000px]",
    };

    const handleBackdropClick = (e) => {
        if (closeOnBackdrop && e.target === e.currentTarget) {
            onClose?.();
        }
    };

    const handleConfirm = () => {
        onConfirm?.();
        onClose?.();
    };

    const handleCancel = () => {
        onCancel?.();
        onClose?.();
    };

    return (
        <div
            className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 backdrop-blur-sm animate-[modal-fade-in_0.3s_ease-out]"
            onClick={handleBackdropClick}
        >
            <div
                className={`${sizeClasses[size]} max-h-[90vh] flex flex-col bg-slate-900/95 backdrop-blur-xl border-2 border-purple-500/50 rounded-[40px] shadow-[0_0_60px_rgba(168,85,247,0.6)] animate-[modal-scale-in_0.3s_ease-out]`}
            >
                {/* 헤더 */}
                <div className="flex items-center justify-between px-16 py-10 border-b border-purple-500/30">
                    <h2 className="text-[2.5rem] font-bold text-transparent bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text">
                        {title || (type === "alarm" ? "알림" : "확인")}
                    </h2>
                    {showCloseButton && (
                        <button
                            onClick={onClose}
                            className="w-12 h-12 flex items-center justify-center rounded-full bg-slate-800/60 border border-slate-600/50 text-slate-400 hover:text-white hover:border-red-400/60 hover:shadow-[0_0_15px_rgba(239,68,68,0.4)] transition-all duration-300"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-6 h-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    )}
                </div>

                {/* 본문 */}
                <div className="flex-1 overflow-y-auto px-16 py-10 text-slate-200 text-[1.8rem] text-center">
                    {message && <p>{message}</p>}
                    {children}
                </div>

                {/* 구분선 */}
                <div className="w-full h-0.5 bg-gradient-to-r from-transparent via-purple-500/50 to-transparent"></div>

                {/* 푸터 - 타입에 따라 버튼 자동 생성 */}
                <div className="flex items-center justify-center gap-6 px-16 py-10">
                    {type === "alarm" ? (
                        <button
                            onClick={handleConfirm}
                            className="min-w-[200px] py-5 px-10 rounded-[16px] text-[1.8rem] font-semibold bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border-2 border-cyan-500/50 text-cyan-400 hover:border-cyan-400 hover:shadow-[0_0_30px_rgba(34,211,238,0.4)] transition-all duration-300"
                        >
                            {confirmText}
                        </button>
                    ) : (
                        <>
                            <button
                                onClick={handleCancel}
                                className="min-w-[200px] py-5 px-10 rounded-[16px] text-[1.8rem] font-semibold bg-slate-700/50 border border-slate-600/50 text-slate-300 hover:bg-slate-600/50 transition-all duration-300"
                            >
                                {cancelText}
                            </button>
                            <button
                                onClick={handleConfirm}
                                className="min-w-[200px] py-5 px-10 rounded-[16px] text-[1.8rem] font-semibold bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-[0_0_20px_rgba(168,85,247,0.5)] hover:shadow-[0_0_30px_rgba(168,85,247,0.7)] transition-all duration-300"
                            >
                                {confirmText}
                            </button>
                        </>
                    )}
                </div>
            </div>

            <style>{`
                @keyframes modal-fade-in {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes modal-scale-in {
                    from { 
                        opacity: 0; 
                        transform: scale(0.95); 
                    }
                    to { 
                        opacity: 1; 
                        transform: scale(1); 
                    }
                }
            `}</style>
        </div>
    );
}

export default CommonModal;
